import { HttpService } from '@services/HttpService'
import { BEARER, APPLICATION_JSON, ACCESS_TOKEN } from '@constants'
import { config } from '@config'
import { storage } from '@services/storageService'

export default class BrandingService {
  private httpService = new HttpService()

  getConfiguration = async () => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}core/configuration/branding`
      const accessToken: string = storage.getItem(ACCESS_TOKEN)

      const result = await this.httpService.get(url, {
        headers: {
          Authorization: `${BEARER} ${accessToken}`,
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON
        }
      })
      return result.data
    } catch (e) {
      console.log('Failed to fetch configuration', e)
      throw new Error('settings.branding.errors.fetchConfiguration')
    }
  }

  updateConfiguration = async (configuration: any) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}core/configuration/branding`
      const accessToken: string = storage.getItem(ACCESS_TOKEN)

      const result = await this.httpService.put(url, configuration, {
        headers: {
          Authorization: `${BEARER} ${accessToken}`,
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON
        }
      })
      return result.data
    } catch (e) {
      console.log('Failed to update configuration', e)
      throw new Error('settings.branding.errors.updateConfiguration')
    }
  }

  //Upload media which is base64 encoded image data as file to the server on /core/media end point
  uploadImage = async (file: any) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}core/media/`
      const accessToken: string = storage.getItem(ACCESS_TOKEN)
      const data = new FormData()
      data.append('file', file)
      const result = await this.httpService.post(url, data, {
        headers: {
          Authorization: `${BEARER} ${accessToken}`
        }
      })
      const key = result.data
      return {
        key,
        imageUrl: `core/media/${key}`,
        fileName: key,
        size: 0,
        canDelete: true
      }
    } catch (e) {
      console.log('Failed to upload image', e)
      throw new Error('settings.branding.errors.uploadImage')
    }
  }

  getImages = async () => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}core/media`
      const accessToken: string = storage.getItem(ACCESS_TOKEN)
      const result = await this.httpService.get(url, {
        headers: {
          Authorization: `${BEARER} ${accessToken}`,
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON
        }
      })
      const response = result.data.map(x => ({
        key: x.key,
        imageUrl: `core/media/${x.key}`,
        fileName: x.fileName,
        size: x.size,
        canDelete: true
      }))
      return response
    } catch (e) {
      console.log('Failed to fetch images', e)
      throw new Error('settings.branding.errors.fetchImage')
    }
  }

  deleteImage = async key => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}core/media/${key}`
      const accessToken: string = storage.getItem(ACCESS_TOKEN)
      const result = await this.httpService.delete(url, {
        headers: {
          Authorization: `${BEARER} ${accessToken}`,
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON
        }
      })
      return result.data
    } catch (e) {
      console.log('Failed to delete image', e)
      throw new Error('settings.branding.errors.deleteImage')
    }
  }
}
